import { useState } from 'react'

import { Divider, Space, Tag, Typography } from 'antd'
import { EyeFilled, LeftOutlined, PlusCircleOutlined, RightOutlined } from '@ant-design/icons';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import CustomModal from '../CustomModal/CustomModal';
import CustomInput from '../CustomInput/CustomInput';
import { useQuery } from '@apollo/client';
import { GET_REMARKS } from '../../Graphql/queries/getQueries';

const RemarkItem = ({ leadId }) => {
    const { error, loading, data } = useQuery(GET_REMARKS, {
        variables: {
            lead_id: leadId
        },
    })
    const [open, setOpen] = useState(false);
    const showModal = () => {
        console.log('showed')
        setOpen(true);
    };
    const handleOk = () => {
        console.log('showed')
        console.log('Clicked Save button ');
        setOpen(false);
    };
    const handleCancel = () => {
        console.log('showed')
        setOpen(false);
    };
    const remarks = data?.Remarks?.nodes.map((item, i) => {
        return { id: i, name: item.user.name, value: item.text, date: item.date, status: item.status }
    })
    // console.log(remarks)
    // const remarks = [{ id: 1, value: 'Remark value' }, { id: 2, value: 'Remark value' }, { id: 3, value: 'Remark value' }]

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        nextArrow: <SlideArrow action='right' />,
        prevArrow: <SlideArrow action='left' />
    };


    return (
        <div className='flex_ver' style={{ gap: 15, minHeight: 0, minWidth: 0 }}>
            <Space direction='vertical' size='large' style={{ paddingTop: 15 }}   >

                <Slider style={{ overflow: 'hidden', width: 0, minWidth: '100%' }} {...settings} >

                    {remarks?.map((remark, i) => <SlideItem key={i} remark={remark} />)}

                </Slider>
                <Divider style={{ width: '100%', margin: 0 }} />
                <div style={{ textAlign: 'end' }}>

                    <PlusCircleOutlined style={{ fontSize: 25, color: 'var(--color-gray)' }} onClick={showModal} />
                    <CustomModal title='Add remark' open={open} handleOk={handleOk} handleCancel={handleCancel} >
                        <CustomInput type='text' name="remark" label='Remark' width='100%' />
                    </CustomModal>
                </div>

            </Space>

        </div>
    )
}

export default RemarkItem
export const SlideItem = ({ remark }) => {
    const [open, setOpen] = useState(false);
    const showModal = () => {
        console.log('showed')
        setOpen(true);
    };
    const handleOk = () => {
        console.log('showed')
        console.log('Clicked Save button from useModel');
        setOpen(false);
    };
    const handleCancel = () => {
        console.log('showed')
        setOpen(false);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%', marginTop: 10 }} >
            <Typography.Text>{remark?.name}</Typography.Text>
            <Typography.Text>{remark?.date}</Typography.Text>
            <Tag color={remark?.status.color} style={{ borderRadius: 8, height: 'fit-content' }} >{remark?.status.text}</Tag>
            <EyeFilled style={{ color: '#8D8D8D', fontSize: 20 }} onClick={showModal} />
            <CustomModal action='view' title='View remark' open={open} handleOk={handleOk} handleCancel={handleCancel} >
                <Typography.Text>{remark?.date}</Typography.Text>
                <Tag color={remark?.status.color} style={{ marginLeft: 10, borderRadius: 8 }} >{remark?.status.text}</Tag>
                <CustomInput disabled type='text' name="remark" label='Remark' width='100%' value={remark?.value} />
            </CustomModal>
        </div>
    )


}
const SlideArrow = ({ className, onClick, action }) => {
    return (
        <div
            className={className}
            onClick={onClick}
        >
            {action === 'right' ?

                <RightOutlined style={{ color: 'var(--color-gray)', fontSize: 25 }} />
                :
                <LeftOutlined style={{ color: 'var(--color-gray)', fontSize: 25 }} />

            }
        </div>
    );
}